import { motion } from "framer-motion";
import { Reveal } from "./motion";
import { useStore } from "../../context/StoreContext";
import { PawPrint } from "lucide-react";

export const FinalCta = () => {
  const { config } = useStore();
  const scrollToPacks = () => document.getElementById("packs")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-ink text-white py-20 sm:py-28 lg:py-36">
      <PawPrint className="absolute -left-10 -top-10 w-56 h-56 text-white/5 rotate-12" />
      <PawPrint className="absolute -right-8 bottom-0 w-40 h-40 text-white/5 -rotate-12" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-balance" data-testid="final-cta-headline">
            {config?.final_cta_headline || "Less hair. More sofa."}
          </h2>
          <p className="mt-6 text-base sm:text-lg text-white/60 max-w-xl mx-auto">
            {config?.final_cta_sub || "Take back your furniture without constantly spending on sticky rollers."}
          </p>
          <motion.button
            data-testid="final-cta-button"
            onClick={scrollToPacks}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.98 }}
            className="mt-10 bg-brand hover:bg-brand-dark text-white font-display font-bold text-lg rounded-full px-12 py-5 shadow-lg shadow-brand/30 transition-colors"
          >
            {config?.final_cta_button || "PEDIR PELOCERO"}
          </motion.button>
        </Reveal>
      </div>
    </section>
  );
};
